import React from 'react'
import HeroSection from '../Components/faq/hero'
import FAQSection from '../Components/faq/faq'
import Banner from '../Components/home/registrationCard'

const faq = () => {
  return (
    <div>
     <HeroSection/>
     <FAQSection />
     <Banner/>
    </div>
  )
}

export default faq
